import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { appConstants } from '../shared/constants/constants';

import { UsersService } from '../pages/users/users.service';
import { FeedbacksService } from '../shared/feedbacks/feedbacks.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authenticatorService: AuthenticatorService,
    private usersService: UsersService,
    private router: Router,
    private feedbacksService: FeedbacksService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const errorType = route.queryParamMap.get('error');

    const userIsBlocked: boolean = this.usersService
      .getActiveUserStatus()
      .endsWith(appConstants.user.codes.blocked);

    if (this.authenticatorService.authStatus === 'authenticated') {
      if (!userIsBlocked) {
        return true;
      } else {
        this.feedbacksService.showFeedback(
          `Usuario bloqueado en Roz.`,
          'danger'
        );
        return this.router.navigate(['/blocked']);
      }
    }
    if (errorType) {
      // Opcional: capturar la descripción
      const errorDescription = route.queryParamMap.get('error_description');
      console.warn('Error capturado en el Guard:', errorDescription);

      // Bloqueamos la ruta y redirigimos
      return this.router.createUrlTree(['/blocked']);
    }
    return this.router.navigate(['/login']);
  }
}
